import { isNil } from "ramda";

interface RateConditionSubjectRef {
  subjectId?: string | null;
  type: string | null;
}

/**
 * Whether a stored condition points at a subject (badge, attribute) the server no longer offers, i.e. the subject
 * was deleted after the ratelist was saved. A condition without a subject id never misses, and an unloaded subject
 * list is not a miss either.
 */
export const isConditionSubjectMissing = (
  rateConditions: RateConditionSubjectRef[] | null | undefined,
  subjectId: string | null | undefined,
  type: string | null | undefined
): boolean =>
  !isNil(subjectId) &&
  !isNil(rateConditions) &&
  !rateConditions.some((subject) => subject.subjectId === subjectId && subject.type === type);
